{
    "dropdown": [{
        "element": "productType",
        "route": "/api/discounttool/productareas/",
        "targetElement": "productArea",
        "targetElementType": "dropdown",
        "reset": ["productArea", "articleGroup"]
    },
    {
        "element": "productArea",
        "route": "/api/discounttool/articlegroups/",
        "targetElement": "articleGroup",
        "targetElementType": "dropdown",
        "reset": ["articleGroup"]
    },
    {
        "element": "articleGroup",
        "route": "/api/discounttool/customerpricesforarticlegroup/",
        "targetElement": "discountToolTable",
        "targetElementType": "table",
        "reset": null
    }],
    "saveSingleRoute" : "/api/discounttool/save",
    "saveAllRoute" : "/api/discounttool/savelist" 
}
